import Box from '@mui/material/Box';
import { DateField, useTranslate } from 'react-admin';
import ExportLabelValue from '@/components/interventions/export-intervention/common/export-label-value';

const ExportInterventionGeneratedDate = () => {
    const translate = useTranslate();

    return (
        <Box
            sx={{
                display: 'grid',
                justifyContent: 'end',
            }}
        >
            <ExportLabelValue
                label={translate('intervention.export.generated_at')}
                value={
                    <DateField
                        record={{
                            date: new Date().toISOString(),
                        }}
                        options={{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                        }}
                        source={'date'}
                        sx={{
                            fontSize: 14,
                            fontWeight: 400,
                            color: 'text.primary',
                        }}
                    />
                }
            />
        </Box>
    );
};

export default ExportInterventionGeneratedDate;
